import { PaginationArg, ResponseWrapper } from 'app/api/types/types'

export enum FAQCategory {
  PROFILE = 'profile',
  ORDER = 'order',
  APPEAL = 'appeal',
  MPLUS = 'mplus',
  DELIVERY = 'delivery',
  PROMO = 'promo',
  OTHER = 'other',
}

export interface FAQItem {
  answer: string
  question: string
}

export interface GetFAQResponse extends ResponseWrapper<FAQItem> {}
export interface GetFAQArgs extends PaginationArg {
  category: FAQCategory
}
